<template>
  <v-row v-if="user">
    <v-col cols="12">
      <v-card-container>
        <UserDataComponent :user="user" @userUpdated="setUser" />
      </v-card-container>
    </v-col>

    <v-col cols="12">
      <v-card-container>
        <UserPermissionComponent
          :permissions="user.permissionsV2"
          :user="user"
          @userUpdated="setUser"
        />
      </v-card-container>
    </v-col>
  </v-row>
</template>

<script setup>
import { onMounted, onBeforeUnmount, computed, ref, watch } from 'vue';

import UserDataComponent from '@/components/common/user/UserDataComponent.vue';
import UserPermissionComponent from '@/components/common/user/UserPermissionComponent.vue';

import { useUsersApi } from '@/composables/api/users/useUsersApi';
import { usePermissions } from '@/composables/usePermissions';
import { useNotification } from '@/composables/useNotification';
import useScopesStore from '@/stores/scopes';
import constants from '@/config/constants';

// Props
const { userHashId } = defineProps({
  userHashId: { type: String, required: true }
});

// Permissions
const { selectedContext } = usePermissions();

// Scope block
const scopesStore = useScopesStore();
const { loadScopeTree, updateSelectedScope } = scopesStore;
const selectedScope = computed(() => scopesStore.selectedScope);

// User block
const { loadSingleUser } = useUsersApi();
const { showErrorAlert } = useNotification();
const user = ref(null);
const setUser = async () => {
  try {
    user.value = await loadSingleUser({ hashId: userHashId });
  } catch {
    showErrorAlert();
  }
};

// Watchers
watch(
  () => userHashId,
  () => setUser()
);

// Hooks
onMounted(() => setUser());
const { PROFILE } = constants.scopeTypes;
onBeforeUnmount(() => {
  if (selectedScope.value === PROFILE)
    updateSelectedScope({ data: null, type: null });
});

selectedContext.value = PROFILE;
updateSelectedScope({ data: null, type: PROFILE });
loadScopeTree({});
</script>
